import { createSelector } from 'reselect';
import { campaignGroupsStateSelector } from './baseSelectors';

export const campaignGroupPickerSortTypeSelector = createSelector(
    campaignGroupsStateSelector,
    campaignGroupsState => campaignGroupsState.campaignGroupPickerSortingType
);

export const campaignGroupPickerSortFieldSelector = createSelector(
    campaignGroupsStateSelector,
    campaignGroupsState => campaignGroupsState.campaignGroupPickerSortingField
);

export const campaignGroupPickerSortOptionsSelector = createSelector(
    campaignGroupPickerSortTypeSelector,
    campaignGroupPickerSortFieldSelector,
    (type, field) => ({ type, field })
);
